import { getTranslatedMessages } from './translates';

$('.first-access-form').validate({
    rules: {
        email: {
            required: true,
            email: true,
        },
        fl_accept: {
            required: true,
        },
    },
    messages: getTranslatedMessages(),
});
